<template>
  <v-chip
    :color="color"
    :text-color="textColor"
    :outlined="outlined"
    small
    class="ma-1"
    @click="cycle"
  >
    {{ tag.name }}
    <span class="ml-2 caption" v-if="judgment !== 'correct'">{{ shortLabel }}</span>
  </v-chip>
</template>

<script>
// Cycles through the judgment states on click. Verifier flow:
//   correct → incorrect_kept → removed_by_verifier → correct
// Tags ADDED by the verifier are tracked separately in the parent (they
// don't pass through this chip — they originate from a separate "add tag"
// autocomplete and are emitted as 'added_by_verifier' immediately).
const CYCLE = ['correct', 'incorrect_kept', 'removed_by_verifier']

export default {
  name: 'TagJudgmentChip',
  props: {
    tag: { type: Object, required: true },        // {id, name, ...}
    judgment: { type: String, default: 'correct' },  // current judgment
  },
  computed: {
    color () {
      switch (this.judgment) {
        case 'correct': return 'success'
        case 'incorrect_kept': return 'warning'
        case 'removed_by_verifier': return 'error'
        case 'added_by_verifier': return 'primary'
        default: return 'grey'
      }
    },
    // Outlined chips sit on a transparent background, so white text is
    // invisible there (IT-713) — use the chip's own color instead.
    textColor () { return this.outlined ? this.color : 'white' },
    outlined () { return this.judgment === 'correct' },
    shortLabel () {
      switch (this.judgment) {
        case 'incorrect_kept': return 'incorrect'
        case 'removed_by_verifier': return 'remove'
        case 'added_by_verifier': return 'added'
        default: return ''
      }
    },
  },
  methods: {
    cycle () {
      const next = CYCLE[(CYCLE.indexOf(this.judgment) + 1) % CYCLE.length]
      this.$emit('change', { tag_id: this.tag.id, judgment: next })
    },
  },
}
</script>
